import dayjs from 'dayjs';
import { DASHBOARD_DATA_STATE } from './dashboardContract';
import { formatDashboardMetricValue } from './dashboardViewModel';

export const DASHBOARD_REVIEW_DECISION = Object.freeze({
  APPROVE: 'approve',
  REJECT: 'reject'
});

export const DASHBOARD_REVIEW_NOTE_MAX_LENGTH = 500;

export const formatDashboardReviewValue = (review, value) =>
  formatDashboardMetricValue(review, {
    dataState: DASHBOARD_DATA_STATE.AVAILABLE,
    value
  });

export const formatDashboardReviewEffectiveDate = (value) =>
  dayjs(value).format('MMM D, YYYY');

export const formatDashboardReviewTimestamp = (value) =>
  dayjs(value).format('MMM D, YYYY [at] h:mm A');

export const validateDashboardReviewDecision = (decision, value) => {
  const note = String(value ?? '').trim();
  if (decision === DASHBOARD_REVIEW_DECISION.REJECT && !note) {
    return {
      error: 'Enter a reason for rejecting this value.',
      isValid: false,
      note
    };
  }
  if (note.length > DASHBOARD_REVIEW_NOTE_MAX_LENGTH) {
    return {
      error: `Enter no more than ${DASHBOARD_REVIEW_NOTE_MAX_LENGTH} characters.`,
      isValid: false,
      note
    };
  }
  return { error: null, isValid: true, note };
};
